import * as React from "react";

import { makeStyles } from "@material-ui/core";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ErrorIcon from "@material-ui/icons/Error";

const useStyles = makeStyles((theme) => ({
  successIcon: {
    color: theme.palette.success.main,
  },
}));

export const AccordionHeaderIcon: React.FC<{
  isError?: boolean;
  show: boolean;
}> = ({ isError, show }) => {
  const classes = useStyles();
  if (!show) {
    return null;
  }
  return isError ? (
    <ErrorIcon
      color="error"
      data-testid="accordionHeaderErrorIcon"
      fontSize="small"
    />
  ) : (
    <CheckCircleIcon
      className={classes.successIcon}
      data-testid="accordionHeaderSuccessIcon"
      fontSize="small"
    />
  );
};
